/* Exporting the environment object. */
/* nvm use 20 & ng serve */
// PROD MODE //
export const environment = {
	production: true,
	appVersion: "2.21.24",
	useMock: false,
	// PROD MODE URL//
	baseAPI: "https://my.guglielmo.biz/api/v2",
	baseDashboard: "https://my.guglielmo.biz/",
	oldVersionDashboardPath: "https://v1.my.guglielmo.biz",
	baseAPIAdmin: "https://my.guglielmo.biz/api/v2/admin",
};
